module.exports = __webpack_public_path__ + "static/img/icon.2dcd5444.png";